/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first, map } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import * as fromProcess from '../../store/process/process.reducer';
import * as fromRemote from '../../store/remote/remote.reducer';
import { ApiState } from '../../model/api-state.model';
import { formatPhoneNumber } from '../../utils';
import { ProcessService } from '../../services/process.service';
import { PersistStorageKeys, PersistStorageService } from '../../services/persist-storage.service';
import { FormsService } from '../../services/forms.service';

@Component({
  selector: 'app-remote-id',
  templateUrl: './remote-id.component.html',
  styleUrls: ['./remote-id.component.scss'],
})
export class RemoteIdComponent implements OnInit {
  id$ = this.activatedRoute.params.pipe(map(({ id }) => (id ? String(id) : null)));
  initState$ = this.store.select(fromRemote.selectInitState);
  initError$ = this.store.select(fromRemote.selectInitError);
  params$ = this.store.select(fromRemote.selectInitParams);
  isActive$ = this.store.select(fromRemote.selectInitIsActive);
  agentName$ = this.params$.pipe(map((params) => params?.agent.agentName));
  agentPhone$ = this.params$.pipe(
    map((params) => (params ? { link: `tel:${params.agent.phoneNumber}`, text: formatPhoneNumber(params.agent.phoneNumber) } : null)),
  );
  agentEmail$ = this.params$.pipe(map((params) => (params ? { link: `mailto:${params.agent.email}`, text: params.agent.email } : null)));

  apiState = ApiState;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private persistStorage: PersistStorageService,
    private processService: ProcessService,
    private formsService: FormsService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(fromProcess.actions.setStep({ step: 8 }));

    this.processService.onPageInit();
    this.persistStorage.setBoolean(PersistStorageKeys.IsRemote, true, 'session');
    this.formsService.resetApp();

    this.id$.pipe(first()).subscribe((id) => {
      if (!id) {
        this.store.dispatch(fromRemote.actions.initError({ error: null }));

        return;
      }

      this.store.dispatch(fromRemote.actions.initStart({ id }));
    });
  }

  sendSmsToken(): void {
    this.id$.pipe(first()).subscribe((id) => {
      void this.router.navigate(['remote', id, 'otp']);
    });
  }
}
